<form
  *ngFor="let form of formulario.controls; index as i"
  [formGroup]="form"
  class="avalista"
>
  <div class="blue-box guarantor">
    <h2>Informações do Avalista {{ i > 0 ? i + 1 : '' }}</h2>
    <div class="row">
      <div
        class="form-group"
        [ngClass]="{ dn: !isConjugeSelected(i) || !fichaCadastro.isPesados }"
      >
        <span class="icon conjuge"></span>
        <div class="inputs">
          <label for="nomeConjuge">Nome</label>
          <input
            class="form-control"
            type="text"
            placeholder="Nome do avalista"
            maxlength="60"
            [required]="isConjugeSelected(i) && fichaCadastro.isPesados"
            appShowErrorMessages
            formControlName="nomeConjuge"
            name="nomeConjuge"
            uppercase
            [charOnly]="true"
            [appMinTwoWords]="isConjugeSelected(i) && fichaCadastro.isPesados"
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon id-number"></span>
        <div class="inputs">
          <label for="cpf">CPF</label>
          <input
            type="text"
            class="form-control"
            formControlName="cpf"
            appShowErrorMessages
            mask-number
            [mask]="'000.000.000-00'"
            placeholder="Digite apenas numeros"
            appCpfValidator
            requiredMessage="O Campo CPF é obrigatório"
            duplicidadeMessage="Você já informou esse CPF para um avalista"
            (blur)="getCpfAvalista(i)"
          />
          <div
            class="text-danger"
            *ngIf="cpfCliente && form.get('cpf').value === cpfCliente"
          >
            o CPF do avalista não pode ser o mesmo do cliente
          </div>
          <div *ngIf="isValidatingAvalistaCpf">
            <i class="fa fa-spinner fa-pulse fa-2x" aria-hidden="true"></i>
            Verificando CPF do Avalista...
          </div>
        </div>
      </div>

      <div class="form-group">
        <span class="icon reference"></span>
        <div class="inputs">
          <label for="grauParentesco">Relação com o Cliente</label>
          <select
            class="form-control"
            formControlName="grauParentesco"
            appShowErrorMessages
            (change)="emitAvalistaConjuge(i)"
          >
            <option value="" hidden selected>Selecione</option>
            <option value="1" *ngIf="!hasConjuge(i)">Cônjuge</option>
            <option value="4">Filho / Filha</option>
            <option value="3">Irmã(o)</option>
            <option value="2">Pai / Mãe</option>
            <option value="0">Outro</option>
          </select>
        </div>
      </div>

      <div class="form-group">
        <span class="icon aniversario"></span>
        <div class="inputs">
          <label for="dataNascimento">Data de Nascimento</label>
          <input
            type="text"
            formControlName="dataNascimento"
            mask-number
            [mask]="'00/00/0000'"
            placeholder="00/00/0000"
            class="form-control"
            appDataValidator
            [dateRange]="dataRange"
            appShowErrorMessages
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon mobile"></span>
        <div class="inputs">
          <label for="celular">Celular do avalista</label>
          <input
            type="tel"
            formControlName="celular"
            appShowErrorMessages
            [minLength]="11"
            [maxLength]="15"
            class="form-control"
            placeholder="(00) 00000-0000"
            duplicidadeMessage="Você já informou esse celular para um avalista"
            appOnlyDigitsLengthValidator
            appTelefone
            appCelularValidator
          />
          <div
            class="text-danger"
            *ngIf="
              celularCliente && form.get('celular').value === celularCliente
            "
          >
            o Celular do avalista não pode ser o mesmo do cliente
          </div>
          <div class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</div>
        </div>
      </div>

      <div class="form-group">
        <span class="icon income"></span>
        <div class="inputs">
          <label for="renda">Renda Comprovada</label>
          <input
            type="text"
            class="form-control"
            placeholder="Digite apenas números"
            [maxLength]="15"
            formControlName="renda"
            [prefix]="'R$'"
            mask-money
            appOnlyMoney
            appRendaValidator
            [valorMaximo]="fichaCadastro?.limiteRenda?.rendaMaxima"
            [valorMaximo]="this.fichaCadastro?.limiteRenda?.rendaMaxima"
            [valorMinimo]="this.fichaCadastro?.limiteRenda?.rendaMinima"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
          />
        </div>
      </div>

      <div
        class="form-group"
        *ngIf="isConjugeSelected(i) && fichaCadastro.isPesados"
      >
        <span class="icon classe-profissional"></span>
        <div class="inputs">
          <label for="classeProfConjuge">Classe Profissional</label>
          <select
            class="form-control"
            appShowErrorMessages
            [required]="isConjugeSelected(i) && fichaCadastro.isPesados"
            requiredMessage="O campo Classe Profissional é obrigatório"
            name="classeProfConjuge"
            formControlName="classeProfConjuge"
            (change)="onClasseProfissionalChange(i)"
          >
            <option value="" selected hidden>Selecione...</option>
            <option
              *ngFor="let classe of classesProfissionaisConjuge"
              value="{{ classe.id }}"
            >
              {{ classe.descricao }}
            </option>
          </select>
        </div>
      </div>

      <div
        class="form-group"
        *ngIf="isConjugeSelected(i) && fichaCadastro.isPesados"
      >
        <span class="icon profissao"></span>
        <div class="inputs">
          <label for="cargoConjuge">Profissão</label>
          <select
            class="form-control"
            [required]="isConjugeSelected(i) && fichaCadastro.isPesados"
            appShowErrorMessages
            requiredMessage="O campo Profissão é obrigatório"
            name="cargoConjuge"
            formControlName="cargoConjuge"
          >
            <option value="" selected hidden>Selecione...</option>
            <option
              *ngFor="let profissao of profissoesConjuge"
              value="{{ profissao.id }}"
            >
              {{ profissao.descricao }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <app-veiculo-proprio
      *ngIf="fichaCadastro.isPesados"
      [isPlacaOpcional]="true"
      labelTitle="Informações do Veículo Próprio do Avalista"
      [veiculo]="form.get('veiculoEmSeuNome').value"
      [veiculos]="getVeiculos(i)"
      (changeForm)="changeFormVeiculoEmSeuNome(i, $event)"
    >
    </app-veiculo-proprio>
  </div>

  <div class="form-group row bg-white" *ngIf="i < 2">
    <span class="icon"></span>

    <div class="switch-group">
      <app-switch
        id="user-guarantor"
        (change)="onClickAddAvalista(i)"
        formControlName="temProximo"
      >
      </app-switch>
      <span class="radio-label">{{ descricaoAddAvalista(i) }}</span>
    </div>
  </div>
</form>

<app-modal
  #modalAvalista
  title="ATENÇÃO"
  [ignoreBackdropClick]="true"
  [hideButtons]="true"
>
  <div class="modal-info">
    <h1>Existe avalista para este CPF</h1>
    <h2>Você deseja</h2>
    <div class="buttons">
      <button (click)="recuperarDadosAvalista()" class="btn btn-full-orange">
        Recuperar os dados
      </button>
      <button (click)="continuar()" class="btn btn-full-orange">
        Continuar
      </button>
    </div>
  </div>
</app-modal>
